import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated, isViewer, isViewerRoute } from "@/lib/auth";

export default function AuthGuard() {
  const location = useLocation();
  if (!isAuthenticated()) {
    const next = location.pathname + location.search;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  if (isViewer() && !isViewerRoute(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
